/** Defaults del "Camino de competencia" de Round Robin según los INSCRITOS
 * reales de la categoría (Cowork 2026-09-20: el default fijo de 4 grupos × 7
 * confundía y dejó al torneo 129 con un Formato que no correspondía a su único
 * grupo de 6). Sin inscritos todavía se conserva el default histórico. */

export interface RoundRobinGroupDefaults {
  groupCount: number;
  playersPerGroup: number;
}

export const LEGACY_ROUND_ROBIN_DEFAULTS: RoundRobinGroupDefaults = { groupCount: 4, playersPerGroup: 7 };

/** Hasta 8 inscritos: un solo grupo. Con más: grupos de ~5 (nunca menos de 3 por grupo). */
export function roundRobinDefaultsForEnrolled(enrolled: number | null | undefined): RoundRobinGroupDefaults {
  const count = Number(enrolled);
  if (!Number.isFinite(count) || count < 2) return LEGACY_ROUND_ROBIN_DEFAULTS;
  if (count <= 8) return { groupCount: 1, playersPerGroup: count };
  const groupCount = Math.max(2, Math.round(count / 5));
  return { groupCount, playersPerGroup: Math.ceil(count / groupCount) };
}
